import Index from './components/Index';
import Orders_v1 from './components/Orders/Index/index.vue';
import Orders_v2 from './components/Orders_v2/Order.vue';
import Expedition from './components/Expeditions_v2/Expedition.vue';
import Edit from './components/Orders_v2/Aggregates/Edit.vue';
import Exportacoes from './components/Orders_v2/Aggregates/Exportacoes.vue';
import Importacao from './components/Orders_v2/Aggregates/Importacao.vue';
import ExportacoesEtiquetas from './components/Orders_v2/Aggregates/ExportacoesEtiquetas.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Index,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Orders_v2,
      },
      {
        path: 'dashboard_v1',
        name: 'dashboard_v1',
        component: Orders_v1,
      },
      {
        path: 'expedition',
        name: 'expedition',
        component: Expedition,
      },
      {
        path: '/dashboard/edit/:item',
        name: 'Edit',
        component: Edit,
      },
      {
        path: '/dashboard/exportacoes',
        name: 'Exportacoes',
        component: Exportacoes,
      },
      {
        path: '/dashboard/importacao',
        name: 'Importacao',
        component: Importacao,
      },
      {
        path: '/dashboard/etiquetas',
        name: 'Etiquetas',
        component: ExportacoesEtiquetas,
      }
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./resources/assets/js/router-config.js